export default __webpack_public_path__ + "static/media/warning.b54fad70.svg";